const initialState = {
  newAddressAndContactsForm: false,
  orgId: null,
  address: null,
  state: null,
  orgCity: '',
  zip: null,
  county: null,
  countyId: '',
  sascaRegion: null,
  postalAddress: null,
  postalCity: null,
  postalZip: null,
  commPhone: null,
  commFax: null,
  commEmail: null,
  commWeb: null,
  contactList: [],
  city: null,
};
export default initialState;
